// extracted by mini-css-extract-plugin
export default {"main":"index_main__RM5qs","operationArea":"index_operationArea__4glQq","mainArea":"index_mainArea__+O6UC"};